import { useState } from "react";
import Vector from "../Assets/Images/Welcome.png";
import Cursor from "../Assets/Images/cursor-left.svg";
import MobileHeaderImage from "../Assets/Images/Mobile-logo-auth.svg";
import { Link, useLocation } from "react-router-dom";
import X_Circle from "../Assets/Icons/x-circle.svg";
import {
  TextField,
  Button,
  InputAdornment,
  IconButton,
  useMediaQuery,
} from "@mui/material";
import axios from "axios";
import WeddinglyLogo from "../Assets/Images/logo-auth.svg";
import ForgotPasswordSuccess from "../Components/ForgotPasswordSuccess";

const PasswordResetRequired = () => {
  const isMobile = useMediaQuery("(max-width: 960px)"); // Detect if the screen is mobile
  const location = useLocation();

  const [Email, setEmail] = useState(location.state?.email || "");
  const [Validation, setValidation] = useState({
    hasError: false,
    errorMessage: "",
  });
  const [IsDone, setIsDone] = useState(false);

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    setValidation({
      hasError: false,
      errorMessage: "",
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission logic
  };

  const handleClearEmail = () => {
    setEmail("");
    setValidation({
      hasError: false,
      errorMessage: "",
    });
  };

  const validateEntry = () => {
    let EmailRegEx = /^[\w.+-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
    if (Email.length === 0) {
      setValidation({
        hasError: true,
        errorMessage: "Please enter your email address.",
      });
    } else if (!EmailRegEx.test(Email)) {
      setValidation({
        hasError: true,
        errorMessage: "Please enter a valid email address.",
      });
    } else {
      sendResetLink();
    }
  };

  const sendResetLink = () => {
    let Req = {
      method: "POST",
      baseURL:
        window.localStorage.getItem("BaseURL") +
        "/api/account/reset-password/init",
      headers: {
        "Content-Type": "text/plain",
      },
      data: Email,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        setIsDone(true);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const inputClasses = {
    "& .MuiOutlinedInput-root": {
      borderRadius: isMobile ? "4px 4px 0 0" : "15px",
      backgroundColor: isMobile ? "#F3EEE6" : "#fff1f2",
      border: "none",
      transition: "background-color 0.3s ease-in-out", // Smooth transition for background
      minWidth: "90% !important", // Updated
      maxWidth: "500px !important", // Updated
      width: "100%",
      fontSize: "20px",
      fontWeight: "600",
      paddingLeft: "10px",
      color: "#171717",
    },

    "& .MuiOutlinedInput-root.Mui-focused": {
      backgroundColor: "#f8e0e0", // Change background on focus
    },

    "& .MuiOutlinedInput-notchedOutline": {
      border: "none !important", // Remove outline border
    },

    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },

    "& .MuiInputBase-input::placeholder": {
      color: "#FB47644D", // Default placeholder color
      transition: "color 0.3s ease-in-out, opacity 0.3s ease-in-out", // Smooth placeholder animation
    },

    "& .MuiInputBase-input:focus::placeholder": {
      color: "#9e7676",
      opacity: 0.9,
    },
  };

  return (
    <main className="auth-wrapper">
      <section className="auth-left-wrapper">
        <div className="auth-vector-container">
          <img className="auth-vector" alt="welcome" src={Vector} />
        </div>
        <img
          src={WeddinglyLogo}
          alt="weddingly logo"
          className="auth-weddingly-logo"
        />
      </section>
      <section className="auth-right-wrapper">
        {!isMobile ? (
          <div className="section-head-action">
            <Link to="/" variant="body2">
              <img alt="" src={Cursor} />
              <p>Back to the login page</p>
            </Link>
          </div>
        ) : null}
        <img alt="" className="mobile-header-image" src={MobileHeaderImage} />
        {IsDone ? (
          <ForgotPasswordSuccess isMobile={isMobile} heading="Set a new password" />
        ) : (
          <form className="auth-form" onSubmit={handleSubmit}>
            <p className="form-head-text">Set a new password</p>
            <span className="signup-success-info">
              <p>
                We've updated the sign-in experience. To continue, please set
                a new password. We'll send a password reset link to your
                email. This is a one-time step.
              </p>
            </span>
            <TextField
              autoComplete="off" // Disable autofill
              fullWidth
              id="email"
              name="email"
              placeholder="Email"
              variant="outlined"
              value={Email}
              onChange={handleEmailChange}
              margin="normal"
              error={Validation.hasError}
              helperText={Validation.errorMessage}
              sx={inputClasses}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {Email && ( // Render clear button only if email has value
                      <IconButton
                        aria-label="clear email"
                        onClick={handleClearEmail}
                        edge="end"
                      >
                        <img alt="x" src={X_Circle} />
                      </IconButton>
                    )}
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              variant="contained"
              onClick={() => validateEntry()}
              sx={{
                backgroundColor: isMobile ? "#F8FAE5" : "#FB4764",
                "&:hover": {
                  backgroundColor: isMobile ? "#F8FAE5" : "#FB4764",
                },
                height: isMobile ? "36px" : "56px",
                fontSize: "25px",
                fontWeight: "400",
                display: "flex",
                color: isMobile ? "#292D32" : "#ffff",
                boxShadow: isMobile ? "none" : "",
                marginTop: isMobile ? "16px" : "10px",
                gridGap: "8px",
                textTransform: "none", // Prevent text from being all caps,
                borderRadius: "15px",
              }}
            >
              Send reset link
            </Button>
          </form>
        )}
      </section>
    </main>
  );
};

export default PasswordResetRequired;
